import { createDependencyType, updateDependencyType, deleteDependencyType } from '../../../../API/dependencies';

// Crear un nuevo tipo de dependencia
/* export const handleAddNewType = (editedTypes, setEditedTypes) => {
  setEditedTypes([...editedTypes, { name: '', isUpdated: false }]);
}; */

export const handleAddNewType = (editedTypes, setEditedTypes) => {
  setEditedTypes([...editedTypes, { name: '', isUpdated: false, isNew: true }]);
};

// Cambiar un tipo de dependencia
export const handleTypeChange = (index, value, editedTypes, setEditedTypes) => {
  const updatedTypes = [...editedTypes];
  updatedTypes[index].name = value;
  updatedTypes[index].isUpdated = true; // Marca que fue modificado
  setEditedTypes(updatedTypes);
};

// Eliminar un tipo de dependencia localmente
export const handleDeleteLocalType = (index, editedTypes, setEditedTypes) => {
  const updatedTypes = editedTypes.filter((_, i) => i !== index);
  setEditedTypes(updatedTypes);
};

// Eliminar un tipo de dependencia desde el backend
export const handleDeleteType = (index, editedTypes, setEditedTypes, deletedTypes, setDeletedTypes, api) => {
  const type = editedTypes[index];

  // Eliminar localmente
  handleDeleteLocalType(index, editedTypes, setEditedTypes);

  if (type.id) {
    // Si tiene id, agregar a la lista de eliminados
    setDeletedTypes([...deletedTypes, type.id]);
  } else {
    //api.warning({ message: "Este tipo de dependencia no tiene id, no se puede eliminar desde el backend." });
  }
};

// Guardar tipos de dependencia (POST, PUT, DELETE)
export const handleSaveTypes = async (editedTypes, deletedTypes, onClose, api) => {
  let hasChanges = false; // Indicador de cambios

  // Nuevos tipos (POST)
  const newTypes = editedTypes.filter(type => !type.id); 
  for (const type of newTypes) {
    try {
      await createDependencyType({ name: type.name });
      hasChanges = true;
    } catch (error) {
      api.error({ 
        message: "Error al guardar el tipo de dependencia",
        description: error?.response?.data?.name?.[0],
        key: 'save-type-error'
      });
      return;
    }
  }

  // Tipos modificados (PUT)
  const updatedTypes = editedTypes.filter(type => type.id && type.isUpdated);
  for (const type of updatedTypes) {
    try {
      await updateDependencyType(type.id, { name: type.name });
      hasChanges = true;
    } catch (error) {
      api.error({ message: "Error al actualizar el tipo de dependencia" });
      return;
    }
  }

  // Eliminar tipos (DELETE)
  for (const deletedTypeId of deletedTypes) {
    try {
      await deleteDependencyType(deletedTypeId);
      hasChanges = true;
    } catch (error) {
      api.error({ message: "Error al eliminar el tipo de dependencia" });
      return;
    }
  }

  // Solo cierra si hubo cambios
  if (hasChanges) {
    api.success({ message: 'Tipos de dependencia guardados correctamente' });
    onClose();
  } else {
    api.info({ 
      message: "No hay cambios para guardar",
      key: 'save-type-info'
    });
  }
};